import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import {
  ServiceModel,
  ServiceCategoryModel,
  ServiceMasterCategoryModel,
} from '../../../../../../store/self-diagnostic/service-catalog/model';
import { List } from '../../../../../../core/infrastructure/linq';
import { TranslateService } from '@ngx-translate/core';
import { ServiceCatalogFacade } from '../../../../../../store/self-diagnostic/service-catalog/facade';
import { AppConstants } from '../../../../../../core/constants/app-constants';
import { UserModel } from '../../../../../../store/user/model';
import { UserFacade } from '../../../../../../store/user/facade';

@Component({
  selector: 'app-service-catalog-categories-details',
  templateUrl: './service-catalog-categories-details.component.html',
  styleUrls: ['./service-catalog-categories-details.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class ServiceCatalogCategoriesDetailsComponent implements OnInit {
  translate = inject(TranslateService);
  private facade = inject(ServiceCatalogFacade);
  private userFacade = inject(UserFacade);

  public user: UserModel;
  public isLanguageUa: boolean;

  @Input('category') public srcCategory: ServiceCategoryModel;
  public category: ServiceCategoryModel;
  @Output('onSave') public onSave$ = new EventEmitter<ServiceCategoryModel>();

  public categories: ServiceCategoryModel[] = [];
  public masterCategories: ServiceMasterCategoryModel[] = [];

  ngOnInit(): void {
    // Get current language
    this.userFacade.selected().subscribe(user => {
      this.user = { ...user };

      this.isLanguageUa = !this.user?.language || this.user?.language == AppConstants.LANGUAGE_UK;
    });

    this.category = { ...this.srcCategory };

    this.facade.entities$.subscribe(s$ => {
      this.categories = new List<ServiceModel>(s$)
        .Select(s => s.category)
        .DistinctBy(sc => sc.code)
        .OrderBy(sc => sc.nameUa)
        .Select(
          sc =>
            <ServiceCategoryModel>{
              id: sc.id,
              code: sc.code,
              nameUa: sc.nameUa,
              nameRu: sc.nameRu,
              webNameUa: sc.webNameUa,
              webNameRu: sc.webNameRu,
              descriptionUa: sc.descriptionUa,
              descriptionRu: sc.descriptionRu,
              iconBody: sc.iconBody,
              iconType: sc.iconType,
              masterCategoryId: sc.masterCategoryId,
              masterCategory: sc.masterCategory,
            }
        )
        .ToArray();

      this.masterCategories = new List<ServiceModel>(s$)
        .Select(s => s.category)
        .Where(sc => sc.masterCategory != null)
        .Select(sc => sc.masterCategory)
        .DistinctBy(mc => mc.code)
        .OrderByDescending(mc => mc.priority)
        .ThenBy(mc => mc.nameUa)
        .Select(
          mc =>
            <ServiceMasterCategoryModel>{
              id: mc.id,
              code: mc.code,
              nameUa: mc.nameUa,
              nameRu: mc.nameRu,
            }
        )
        .ToArray();
    });
  }

  public save() {
    this.onSave$.emit(this.category);
  }
}
